import { NgZone } from '@angular/core';
import * as i0 from "@angular/core";
import * as i1 from "./sse.service";
import * as i2 from "@angular/common/http";
var PumpService = /** @class */ (function () {
    function PumpService(_zone, _sseService, http) {
        this._zone = _zone;
        this._sseService = _sseService;
        this.http = http;
    }
    PumpService.prototype.pumpdashboard = function (body) {
        return this.http.post("getPumpData", body);
    };
    PumpService.prototype.getPumpIds = function (body) {
        return this.http.post("getPumpIdsArray", body);
    };
    PumpService.prototype.getPumpDataTile = function (body) {
        return this.http.post("getPumpDataTile", body);
    };
    PumpService.prototype.getSelectedPumpData = function (body) {
        return this.http.post("getSelectedPumpData", body);
    };
    PumpService.prototype.getPumpAlerts = function (body) {
        return this.http.post("getPumpAlerts", body);
    };
    PumpService.prototype.gatewayReport = function (body) {
        return this.http.post("pumpgatewayReport", body);
    };
    PumpService.prototype.savePumpData = function (data) {
        var payload = data;
        return this.http.post('addUpdatePump', payload);
    };
    PumpService.prototype.getPumpData = function (roleid, userid, module) {
        return this.http.get("getPumpData?roleid=" + roleid + "&userid=" + userid + "&module=" + module);
    };
    PumpService.prototype.getPumpids = function () {
        return this.http.get('getPumpids');
    };
    PumpService.prototype.getTransformerIds = function () {
        return this.http.get('getTransformerIds');
    };
    PumpService.prototype.getPumpDetails = function (data) {
        var payload = data;
        return this.http.get("getPumpDetails?pumpId=" + data.pumpId + "&deletedFlag=" + data.deletedFlag);
    };
    PumpService.prototype.deletePump = function (data) {
        var payload = data;
        return this.http.post('deletePump', payload);
    };
    PumpService.prototype.alertReport = function (data) {
        var payload = data;
        return this.http.post('alertReport', payload);
    };
    PumpService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function PumpService_Factory() { return new PumpService(i0.ɵɵinject(i0.NgZone), i0.ɵɵinject(i1.SseService), i0.ɵɵinject(i2.HttpClient)); }, token: PumpService, providedIn: "root" });
    return PumpService;
}());
export { PumpService };
